import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'

const HIDDEN_PATHS = ['/app', '/login', '/signup', '/reset', '/auth', '/pricing']

export default function MobileStickyCTA() {
  const location  = useLocation()
  const [visible,   setVisible]   = useState(false)
  const [dismissed, setDismissed] = useState(false)

  const isHiddenPath = HIDDEN_PATHS.some(p => location.pathname.startsWith(p))

  // Check sessionStorage on mount
  useEffect(() => {
    if (sessionStorage.getItem('cta_dismissed') === '1') setDismissed(true)
  }, [])

  // Scroll listener — show after 600 px
  useEffect(() => {
    if (isHiddenPath || dismissed) return
    function onScroll() { setVisible(window.scrollY > 600) }
    window.addEventListener('scroll', onScroll, { passive: true })
    onScroll()
    return () => window.removeEventListener('scroll', onScroll)
  }, [isHiddenPath, dismissed, location.pathname])

  function handleDismiss() {
    setDismissed(true)
    sessionStorage.setItem('cta_dismissed', '1')
  }

  if (isHiddenPath || dismissed || !visible) return null

  return (
    <div
      className="fixed inset-x-0 bottom-0 z-50 border-t border-ink-300 bg-white/95 backdrop-blur px-4 pt-3 md:hidden shadow-[0_-2px_10px_rgba(0,0,0,0.05)]"
      style={{ paddingBottom: 'max(0.75rem, env(safe-area-inset-bottom))' }}
      role="complementary"
      aria-label="Quick actions"
    >
      <div className="flex gap-2 max-w-container mx-auto">
        <Link
          to="/signup"
          className="flex-1 inline-flex items-center justify-center min-h-12 rounded-lg bg-brand-600 text-white font-semibold text-sm plausible-event-name=cta_click plausible-event-location=sticky_cta plausible-event-kind=start_free"
        >
          Start free
        </Link>
        <Link
          to="/pricing"
          className="inline-flex items-center justify-center min-h-12 px-4 rounded-lg border border-ink-300 text-ink-900 font-medium text-sm plausible-event-name=cta_click plausible-event-location=sticky_cta plausible-event-kind=pricing"
        >
          Pricing
        </Link>
        <button
          onClick={handleDismiss}
          aria-label="Dismiss"
          className="min-h-12 min-w-12 rounded-lg border border-ink-300 text-ink-500 text-xl leading-none"
        >
          ×
        </button>
      </div>
    </div>
  )
}
